import { Component } from '@angular/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {

	private teamTag: string = ``;
	private teamSuffix: string = ``
	private playerName: string = `IAmColbat`;
	private playerSuffix: string = ``;

	private playerTags: any[] = [
		{ type: 'Battle.Net', tag: 'UEColbat#1979' },
		{ type: 'Steam', tag: 'IAmColbat', link: 'http://steamcommunity.com/id/iamcolbat' },
		{ type: 'Origin', tag: 'IAmColbat' },
		{ type: 'Battlefield: 3 / 4 / Hardline', tag: 'IAmColbat' }
	];

	private contacts: any[] = [
		{ type: 'Facebook', link: 'https://www.facebook.com/iamcolbat/' },
		{ type: 'Twitch', link: 'http://twitch.tv/iamcolbat' }
	];

	private intro: string = `
		Ex-pro player for BF.Nut and Unestablished. Ex-Coach for Team SMG. Colbat started out with Starcraft 1, transitioning to FPS starting with Battlefield 2.<br/><br/>
		Played for BF.Nut winning regional and oceanic tournaments before leaving the team due to work commitments.<br/><br/>
		Joined Unestablished a year later forming UE.FMH. FMH was the most dominant in SG for 2016, winning all LAN tournaments they played in.<br/><br/>
		Colbat was also part of the team for Blizzcon 2016, the only SG team to date, that made it out of group stages and attended Blizzcon.<br/><br/>
		In 2020, Colbat was coach for GMCC and Team SMG winning a slew of tournaments.
	`;

	private accolades: any[] = [
		{
			type: "Valorant",
			role: "Team SMG - Coach",
			list: [
				{
					date: "2020 Oct",
					tournament: "TheGYM SG Invitational",
					position: "Champion"
				},
				{
					date: "2020 Sep",
					tournament: " BRSG Valorant Community Series",
					position: "Champion"
				},
				{
					date: "2020 Sep",
					tournament: " A.W EXTREME MASTERS ASIA Invitational",
					position: "7th/8th"
				},
				{
					date: "2020 Sep",
					tournament: " AfreecaTV Valorant Showdown",
					position: "3rd Runner Up",
				},
				{
					date: "2020 Aug",
					tournament: " Valorant Bad Blood S1",
					position: "Champion",
				},
				{
					date: "2020 Aug",
					tournament: " Cyber Games Arena x Ignition Asia Pacific",
					position: "3rd Runner Up"
				},
				{
					date: "2020 Jul",
					tournament: " Rise of Legion : Valorant July 2020",
					position: "2nd Runner Up"
				},
				{
					date: "2020 Jul",
					tournament: " BRSG Valorant Community Series 2020 by BRSG #VALORANTSG",
					position: "2nd Runner Up"
				},
				{
					date: "2020 Jul",
					tournament: " Valorant Bad Blood S1 Prequel",
					position: "2nd Runner Up"
				},
				{
					date: "2020 Jun",
					tournament: " Battle Royale Singapore",
					position: "Champion",
				},
				{
					date: "2020 Jun",
					tournament: " Stay Home Challenger Breaker",
					position: "Champion"
				}, {
					date: "2020 Jun",
					tournament: " VALORANT Showdown Week 1",
					position: "Champion"
				},
			]
		},
		{
			type: "Overwatch",
			role: "Team UE - Player",
			list: [{
				date: "2017 Feb",
				tournament: "MSI MGA Overwatch",
				position: "Champion"
			}, {
				date: "2016 Oct",
				tournament: "Overwatch Bootcamp by Nvidia and MSI",
				position: "1st Runner Up"
			}, {
				date: "2016 Oct",
				tournament: "Blizzcon Invitational 2016 (SG Representitive)",
				position: "RO16"
			}, {
				date: "2016 Sept",
				tournament: "Singapore eSports League (SeL)",
				position: "Champion"
			}, {
				date: "2016 June",
				tournament: "Aorus Cup",
				position: "Champion"
			}, {
				date: "2016 June",
				tournament: "Blizzard Singapore Overwatch Showmatch",
				position: "Champion "
			}, {
				date: "2016 May",
				tournament: "Overwatch Community Competitive Tournament #1",
				position: "Champion"
			}]
		},
		{
			type: "Battlerite",
			list: [
				{
					date: "2016 Sept",
					tournament: "ESL Battlerite #1",
					position: "2nd Runner up"
				}
			]
		},
		{
			type: "Battlefield 4",
			role: "Team BF.Nut - Player",
			list: [{
				date: "2014 August",
				tournament: "32v32 BF4 Asia International Cup",
				position: "3rd Runner Up"
			},
			{
				date: "2014 April",
				tournament: "BF4 Go4BF4 Series Cup #5",
				position: "Champion"
			},
			{
				date: "2014 March",
				tournament: "BF4 Go4BF4 Series Cup #3",
				position: "Champion"
			},
			{
				date: "2014 March",
				tournament: "BF4 Go4BF4 Series Cup #2",
				position: "Champion"
			},
			{
				date: "2014 March",
				tournament: "BF4 Go4BF4 Series Cup #1",
				position: "1st Runner Up"
			},
			{
				date: "2014 Jan",
				tournament: "Battlefield 4 Palit Asia Cup",
				position: "Champion"
			},
			{
				date: "2013 Dec",
				tournament: "Battlefield 4 King Of The Hill Community Event",
				position: "Champion"
			}]
		},
		{
			type: "Battlefield 3",
			role: "Team BF.Nut - Player",
			list: [{
				date: "2012 Feb",
				tournament: "SEA Gigabyte Battlefield 3",
				position: "Champion"
			}]
		},
		{
			type: "Battlefield Badcompany 2",
			role: "Team BF.Nut - Player",
			list: [{
				date: "2010 Sept",
				tournament: "Fragnetics Battlefield Bad Company 2 Online Competition",
				postion: "Champion"
			}]
		},
		{
			type: "Battlefield 2",
			list: [{
				date: "2008",
				tournament: "New Paper Challenge 08'",
				position: "3rd Runner Up"
			}]
		},
		{
			type: "Blackshot",
			role: "Team BF.Nut - Player",
			list: [{
				date: "2010 May",
				tournament: "Colosseum Blackshot SD Competition",
				position: "2nd Runner Up",
			}, {
				date: "2010 March",
				tournament: "Blackshot Choco Trio Tourney 3v3 (SG)",
				position: "Champion",
			}, {
				date: "2009 June",
				tournament: "World Cyber Games SAFRA Champion's League",
				position: "1st Runner Up",
			}, {
				date: "2009 March",
				tournament: "Intersession E-Gaming Challenge",
				position: "Top 16",
			}]
		},
		{
			type: "Call of Duty 4 - Promod",
			role: "Team BF.Nut - Player",
			list: [
				{
					date: "2009",
					tournament: "Asean Call of Duty 4 Championships",
					position: "Top 16"
				}
			]
		}
	]

};



// WEBPACK FOOTER //
// ./src/app/app.component.ts